import { ModelEvents } from "@denishussar/html5-game-engine"
import { getCommonConfig } from "../../Common/GameConfig";
import { sampleFromArray } from "../../Common/Utils";
import { GeneratorEvenets } from "../../Constants/Events";
import { GameMoveableObstacleController } from "../../Controllers/Game/obstacles/moveable/GameMoveableObstacleController";
import { GameModel, GameMoveableObstacleTypeEnum, GameObstacleTypeEnum, GenObstacleEnum } from "../../Models/GameModel"
import { IGenParams } from "../../Utils/AbstractGenerator/AbstractGenerator"
import { Entity } from "../../Utils/AbstractGenerator/Entity"
import { Random } from "../../Utils/Math";
import { GameLogic } from "../GameLogic";
import { InchGenerator } from "./Generator";

export class MedEntity implements Entity {
    private obstacleDistance: number;
    private obstacles = [
        // GameMoveableObstacleTypeEnum.golf,
        GameMoveableObstacleTypeEnum.degen,
    ]

    private cars = [
        GameMoveableObstacleTypeEnum.golf,
        GameMoveableObstacleTypeEnum.hummer,
    ]

    private previous = GameObstacleTypeEnum.none;
    constructor(
        private model: GameModel,
        private generator: InchGenerator,
        private events: ModelEvents,
    ) {
        this.obstacleDistance = getCommonConfig('obstacleDistance');
    }

    usefulness() {

        return <IGenParams>{ low: 0, med: 1, high: 0 }
    }

    spawn() {
        const prev = this.model.generator.generated[this.model.generator.generated.length - 1];
        if(prev.type == GenObstacleEnum.med) {
            this.generator.stupidity = 0.8;
            this.generator.spawn();
            this.generator.stupidity = 0.2;
            return;
        }
        if ((this.model.playerDistance - this.model.generator.lastObstacleDistance) < this.model.generator.beforeStaticDistance) return;
        this.model.generator.lastObstacleDistance = this.model.playerDistance;
        let type = sampleFromArray(this.obstacles, 0);
        // while (type == this.previous) {
            type = sampleFromArray(this.obstacles, 0);
        // }
        this.previous = type;

        let road = 0;
        let roads = [-1, 0, 1];
        let lastRoad;
        try {
            lastRoad = this.model.generator.generated[this.model.generator.generated.length - 1].road;
            roads = roads.filter(e => e != lastRoad);
        }
        catch {
            lastRoad = 2;
        }


        switch (type) {
            case GameMoveableObstacleTypeEnum.degen:
                road = Math.round(Random()) ? -1 : 1;
                // this.events.dispatch(this.model, GeneratorEvenets.addMoveableObstacle, type, road );
                this.model.gameScreen.createMoveableObstacleController({ type, roadIndex: road });
                break;
        }
        this.model.generator.lastObstacleDistance = this.model.playerDistance;
        this.model.generator.generated.push({ type: GenObstacleEnum.med, distance: this.model.playerDistance, road, obstacleType: type })
    }
}